export default "__VITE_ASSET__c01b052d__"